"use client";

import { usePathname } from "next/navigation";
import { type ThemeProviderProps } from "next-themes";

import { ThemeProvider } from "./theme-provider";

// The embedded chat sits inside another company's page, so it always renders
// light instead of following the viewer's system theme.
export function RouteThemeProvider(props: ThemeProviderProps) {
  const pathname = usePathname();
  const forcedTheme = pathname?.startsWith("/embed/") ? "light" : undefined;
  return <ThemeProvider {...props} forcedTheme={forcedTheme} />;
}
